<tui-root>
  <!-- Pantalla de carga mientras se verifica la sesión de Cognito -->
  <div *ngIf="!(initialized$ | async)" class="auth-loading-screen">
    <mat-spinner diameter="48" color="primary"></mat-spinner>
  </div>

  <ng-container *ngIf="initialized$ | async">
    <app-backoffice *ngIf="(isLoggedIn$ | async) && isBackofficeRoute()"></app-backoffice>

    <mat-drawer-container class="!h-full" *ngIf="isLoggedIn$ | async">
      <!--Menu lateral-->
      <mat-drawer
        #drawer
        class="w-64 px-6 py-16 "
        mode="over"
      >
       <img src="https://cdn.zendy.tel/images/zendy-red.svg"
        class="h-10 hover:opacity-80 transition"
        style="width: 200px;"
        />
      
        <!-- <app-profile></app-profile> -->
        <app-menu></app-menu>
         <img src="https://cdn.zendy.tel/images/Powered-by-T.png"
        class="h-10 hover:opacity-80 transition"
        style="width: 200px;"
        />
      </mat-drawer>
      <mat-drawer-content>
        <!--HEADER-->
        <app-header class="sticky" (onOpenMenu)="drawer.toggle()"></app-header>
        <!--<div id="content" class="md:max-w-4xl md:m-auto">-->
        <!--contenido-->
        <div id="content" class="mx-auto px-6 lg:px-8" 
             [class.backoffice-content]="isBackofficeRoute()"
             [class.max-w-2xl]="!isBackofficeRoute()"
             [class.lg:max-w-7xl]="!isBackofficeRoute()"
             [class.max-w-full]="isBackofficeRoute()">
          <div class="custom-container">
            <router-outlet></router-outlet>
          </div>
        </div>

        <app-tabs *ngIf="isMobile && !isIos"></app-tabs>
      </mat-drawer-content>
    </mat-drawer-container>
    <div *ngIf="!(isLoggedIn$ | async)">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
</tui-root>

<style>
  .menulateral{
    background-color: white;
    color: black;
  }
</style>